import { initializeDataDictionaryDrawer } from "./data-dictionary-drawer"
import { initializeDataDictionaryModal } from "./data-dictionary-modal"
import { InitDataDictionarySelector } from "./data-dictionary-selector"

import { setPaginationEvents, setNavigationEvents } from "./pagination"

document.addEventListener("DOMContentLoaded", async () => {
    initializeDataDictionaryDrawer()
    initializeDataDictionaryModal()
    await InitDataDictionarySelector()

    // Pagination

    const previousPageElement = document.querySelector(".pagination-js-search-previous")
    const nextPageElement = document.querySelector(".pagination-js-search-next")
    const paginationElements = document.getElementsByClassName("pagination-js-search")

    setPaginationEvents(paginationElements)
    setNavigationEvents(previousPageElement)
    setNavigationEvents(nextPageElement)
})
